"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateLoading = exports.useLoading = void 0;
var useLoading_1 = __importDefault(require("./useLoading"));
exports.useLoading = useLoading_1.default;
var useUpdateLoading_1 = __importDefault(require("./useUpdateLoading"));
exports.useUpdateLoading = useUpdateLoading_1.default;
